// extracted by mini-css-extract-plugin
export var deliveryRow = "_sq-a";
export var fixedHeight = "_sq-4";
export var freightLogo = "_sq-9";
export var fullWidth = "_sq-3";
export var priceColumn = "_sq-5";
export var radioSelected = "_sq-7";
export var radioUnselected = "_sq-6";
export var selectedOption = "_sq-2";
export var selectedOptionContainer = "_sq-1";
export var selection = "_sq-0";
export var tallSkeletonText = "_sq-8";